import React, { useState, useMemo } from 'react'
import { debounce } from 'lodash'
import { Collapse, Spin, Row, Col, Button, Tag, message, Popconfirm } from 'antd'
import './style.less'
import { PlusOutlined } from '@ant-design/icons'
import PreviewCompliance from '../quality-check-scheme-detail/components/preview-compliance'
import PreviewMoc from '../quality-check-scheme-detail/components/preview-moc'
import PreviewScenarioTag from '../quality-check-scheme-detail/components/preview-scenario-tag'
import { QcType, QcTypeMap, QcSchemeStatusMap } from '../quality-check-scheme-detail/constants'
import { Link } from 'react-router-dom'
import { getAIQualityCheckPlanList, getAIQualityCheckPlanDetail, copyAIQualityCheckPlan, deleteAIQualityCheckPlan, submitSchemeOptimize } from '@services/ai-quality-check'
import { useService, useShowError } from '@hooks'

const { Panel } = Collapse
const emptyParams = {}
export default function MyCollapse () {
  const [activeKey, setActiveKey] = useState([])
  const [details, setDetails] = useState({}) // { [id]: detailData }
  const [loading, setLoading] = useState({}) // { [id]: boolean }
  const [loadingList, panelListRes, err, forceRequest] = useService(getAIQualityCheckPlanList, emptyParams)
  useShowError('获取质检方案列表失败', err)
  const list = useMemo(() => panelListRes?.list || [], [panelListRes])
  // 模拟异步获取详情
  const fetchDetail = async (id: number) => {
    setLoading((prev) => ({ ...prev, [id]: true }))
    const [res, err] = await getAIQualityCheckPlanDetail({ plan: [{ planId: id }] })
    if (err) {
      message.error(`获取质检方案详情失败:${err.message}`)
      return
    }
    const data = res.list.find(item => item.id === id)
    setDetails((prev) => ({ ...prev, [id]: data }))
    setLoading((prev) => ({ ...prev, [id]: false }))
  }

  const handleChange = (keys) => {
    setActiveKey(keys)
    keys.forEach((k) => {
      if (!details[k] && !loading[k]) {
        fetchDetail(Number(k))
      }
    })
  }

  const renderContent = (qcType: number, qcId: number) => {
    switch (qcType) {
      case QcType.compliance:
        return <PreviewCompliance qcPlanDetail={details[qcId]} />
      case QcType.moc:
        return <PreviewMoc qcPlanDetail={details[qcId]} />
      case QcType.scenarioTag:
        return <PreviewScenarioTag qcPlanDetail={details[qcId]} />
      default:
        return null
    }
  }
  const handleSubmitOptimize = (id: number) => debounce(async () => {
    const [, err] = await submitSchemeOptimize({ planId: id })
    if (err) {
      message.error(`提交调优失败:${err.message}`)
    } else {
      message.success('提交调优成功')
      forceRequest()
    }
  }, 500, { leading: true, trailing: false })

  const handleCopyScheme = (id: number) => debounce(async () => {
    const [res, err] = await copyAIQualityCheckPlan({ planId: id })
    if (err) {
      message.error(`复制方案失败: ${err.message}`)
      return
    }
    message.success('复制方案成功')
    forceRequest()
  }, 500, { leading: true, trailing: false })

  const handleEditScheme = (id: number) => debounce(() => {
    window.open(`/config/quality-check-scheme-detail/${id}`, '_blank')
  }, 500, { leading: true, trailing: false })

  const handleDeleteScheme = (id: number) => debounce(async () => {
    const [res, err] = await deleteAIQualityCheckPlan({ planId: id })
    if (err) {
      message.error(`删除方案失败: ${err.message}`)
      return
    }
    message.success('删除方案成功')
    forceRequest()
  }, 500, { leading: true, trailing: false })
  return (
    <div className="quality-check-scheme-container">
      <Link className="create-scheme-btn" to="/config/quality-check-scheme-detail" target="_blank">
        <span className="btn-icon">+</span>
        <span>新建质检方案</span>
      </Link>
      <Spin spinning={loadingList}>
        <Collapse className="scheme-collapse" activeKey={activeKey} onChange={handleChange} ghost>
          {list.map((item) => (
            <Panel
              collapsible="header"
              extra={
                <div style={{ height: 44, display: 'flex', alignItems: 'center' }}>
                  <Button style={{ marginLeft: 20 }} onClick={handleCopyScheme(item.id)}>
                    复制方案
                  </Button>
                  <Button style={{ marginLeft: 20 }} onClick={handleSubmitOptimize(item.id)}>
                    提交调优
                  </Button>
                  <Button type="primary" style={{ marginLeft: 20 }} onClick={handleEditScheme(item.id)}>
                    编辑方案
                  </Button>
                  <Popconfirm title="确定删除该方案吗？" onConfirm={handleDeleteScheme(item.id)}>
                    <Button danger type="primary" style={{ marginLeft: 20 }}>
                      删除方案
                    </Button>
                  </Popconfirm>
                </div>
              }
              header={(
                <div style={{ height: 44, display: 'flex', alignItems: 'center' }}>
                  <span className="text-truncate" style={{ maxWidth: '500px' }}>方案名称：{item.name}</span>
                  <Button type="dashed" size="small" style={{ borderColor: '#1890ff', color: '#1890ff', marginLeft: 20 }}>
                    #{QcTypeMap[item.type]}
                  </Button>
                  <Tag color={QcSchemeStatusMap[item.status as keyof typeof QcSchemeStatusMap]?.color} style={{ marginLeft: 10 }}>{QcSchemeStatusMap[item.status as keyof typeof QcSchemeStatusMap]?.text}</Tag>
                </div>

              )} key={item.id}>
              {loading[item.id] ? (
                <Spin />
              ) : details[item.id] ? renderContent(item.type, item.id) : null}
            </Panel>
          ))}
        </Collapse>
      </Spin>
    </div>
  )
}
